import React, { useMemo } from 'react';
import { path } from 'ramda';

import { Jackpot } from '@interlayer/js/app/components/common/Jackpot';

import I18n from 'js/components/common/I18n';

import {
    ADDITIONAL_SPACE,
    ELEMENT_LENGTH_FOR_DESKTOP,
    ELEMENT_LENGTH_FOR_MOBILE } from 'js/app/components/main/FeaturedBanner/components/FeaturedSlide/constants';
import { useInDesktop } from 'js/app/hooks/device/hooks/useMediaQuery';
import { useTranslations } from 'js/hooks/i18n';
import { JACKPOTS_REDUCER } from 'js/store/constants';
import { useCustomSelector } from 'js/store/hooks';

import style from './JackpotWidget.scss';

export const JackpotWidget = ({ options = {} }) => {
    const { jackpotCode, color, opacity } = options;
    const isDesktop = useInDesktop();
    const jackpot = useCustomSelector(JACKPOTS_REDUCER, path(['jackpots', jackpotCode]));

    const calculationMinWidthJackpotContainer = useMemo(
        () => {
            const jackpotAmount = jackpot?.amount.toFixed(2);

            if (isDesktop) {
                return `${jackpotAmount?.length * ELEMENT_LENGTH_FOR_DESKTOP + ADDITIONAL_SPACE}rem`;
            }

            return `${jackpotAmount?.length * ELEMENT_LENGTH_FOR_MOBILE + ADDITIONAL_SPACE}vw`;
        },
        [isDesktop, jackpot]
    );

    const t = useTranslations('playtech.mobile.system.featuredbanner.jackpot.');

    if (!jackpot) {
        return null;
    }

    return (
        <div className={style.wrap}>
            <div
                style={{ color }}
                className={style.container}
            >
                <div
                    className={style.substrate}
                    style={{
                        opacity,
                        border: color ? `1.5px solid ${color}` : '',
                        boxShadow: color ? `0 0 5px 0 ${color}` : ''
                    }}
                />

                <I18n
                    t={t}
                    tKey="title"
                    className={style.title}
                />

                <Jackpot
                    styleCustom={{ minWidth: calculationMinWidthJackpotContainer }}
                    jackpotCode={jackpotCode}
                    className={style.jackpot}
                />
            </div>
        </div>
    );
};
